// extracted by mini-css-extract-plugin
export default {"shimmer":"shimmer__Ijqw8","gradient":"gradient__8Zrv1"};